






import Vue from 'vue'
import _ from 'lodash'
import * as types from '@/store/modules/play/types'

interface State {
  container: HTMLElement | null;
  canvas: HTMLCanvasElement | null;
  ctx: CanvasRenderingContext2D | null;
  height: number;
}

export default Vue.extend({
  name: 'TrackBorder',

  props: {
    width: Number,
    isSelected: Boolean,
    isPlaying: Boolean,
    isRecording: Boolean,
  },

  data (): State {
    return {
      container: null,
      canvas: null,
      ctx: null,
      height: 0,
    }
  },

  mounted () {
    // 要素の参照を取得
    this.container = this.$refs.container as HTMLElement
    const canvas = this.$refs.canvas as HTMLCanvasElement
    this.canvas = canvas
    this.ctx = canvas.getContext('2d')

    // TODO 高さの取得がうまく取れていないことがある
    this.getHeight()
    setInterval(this.getHeight, 500)

    // リサイズで高さをフィット
    // TODO 間引く？
    window.addEventListener('resize', this.throttleGetHeight)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.throttleGetHeight)
  },

  computed: {
    /**
     * 1秒あたりのトラックの幅
     */
    trackWWidthPerSecond (): number {
      return this.$store.state[types.moduleName].trackWidthPerSecond
    },

    /**
     * BGMの再生時間
     */
    duration (): number {
      return this.$store.state[types.moduleName].duration
    },

    /**
     * 音が鳴っている時間
     */
    validDuration (): number {
      // 残り3秒は無音なので対象外
      return this.duration - 3
      // return this.duration
    },

    /**
     * 1小節の幅
     */
    barDuration (): number {
      return this.$store.state[types.moduleName].barDuration / 4
    },

    /**
     * 1小節の幅
     */
    measureWidth (): number {
      return this.$store.state[types.moduleName].barDuration * this.trackWWidthPerSecond
    },

    /**
     * 1拍の幅
     */
    beatWidth (): number {
      return (this.$store.state[types.moduleName].barDuration / 4) * this.trackWWidthPerSecond
    },

    /**
     * 小節の数
     */
    numMeasure (): number {
      return Math.ceil(this.validDuration / this.$store.state[types.moduleName].barDuration)
    },

    /**
     * 拍の数
     */
    numBeat (): number {
      return Math.ceil(this.validDuration / this.barDuration)
    },

    /**
     * 縦線の色
     */
    borderColor (): string {
      // // 収録中、選択中、選択、未選択によって色を変える
      // if (this.isRecording) {
      //   return 'rgb(255, 209, 216)' // darken(#ffebee, 5%)
      // } else if (this.isSelected || this.isPlaying) {
      //   return 'rgb(242, 242, 242)'  // darken(#ffffff, 5%)
      // } else {
      //   return 'rgb(225, 225, 225)'  // darken(#eeeeee, 5%)
      // }

      if (this.isRecording) {
        // 収録中
        return 'rgb(196, 196, 196)' // #c4c4c4
      } else {
        return 'rgb(220, 220, 220)' // #dcdcdc
      }
    },

    /**
     * 枠線の色（強調）
     */
    strongBorderColor (): string {
      // 収録中、選択中、選択、未選択によって色を変える
      if (this.isRecording) {
        return 'rgb(255, 133, 151)' // darken(#ffebee, 20%)
      } else if (this.isSelected || this.isPlaying) {
        return 'rgb(204, 204, 204)'  // darken(#ffffff, 20%)
      } else {
        return 'rgb(187, 187, 187)'  // darken(#eeeeee, 20%)
      }
    },

    measureBackgroundDarkColor (): string {
      if (this.isRecording) {
        return 'rgb(241, 211, 216)'
      } else {
        return 'rgb(237, 237, 237)'
      }
    },
  },

  methods: {
    /**
     * 描画
     */
    draw () {
      this.fitCanvas()

      if (this.ctx) {
        // 線の基本スタイル
        this.ctx.lineWidth = 2

        this.ctx.clearRect(0, 0, this.width, this.height)

        // // TEST Canvasにレンダリングできているか
        // this.ctx.fillStyle = 'rgb(0, 0, 255)'
        // this.ctx.fillRect(20, 0, 50, 200)

        // 小節数

        // 小節の背景を交互に濃い色にする
        for (let i = 1; i < this.numMeasure; i++) {
          if (i % 2 === 1) {
            const x = Math.round(i * this.measureWidth)
            this.ctx.fillStyle = this.measureBackgroundDarkColor
            this.ctx.fillRect(x, 0, this.measureWidth, this.height)
          }
        }

        // 縦線を引く
        // 最後の3秒は無音なので色をつけない
        for (let i = 1; i < this.numBeat; i++) {
          // if (i % 4 === 0) {
          //   // 小節？の区切りには強調した枠線を表示
          //   this.ctx.strokeStyle = this.strongBorderColor
          // } else {
          //   this.ctx.strokeStyle = this.borderColor
          // }
          this.ctx.strokeStyle = this.borderColor

          const x = Math.round(i * this.beatWidth)
          this.ctx.beginPath()
          // 線を細く表示するため0.5pxずらす
          // see https://usefulangle.com/post/17/html5-canvas-drawing-1px-crisp-straight-lines
          this.ctx.moveTo(x + 0.5, 0)
          this.ctx.lineTo(x + 0.5, this.height)
          this.ctx.closePath()
          this.ctx.stroke()
        }
      }
    },

    /**
     * canvasのサイズをフィット
     */
    fitCanvas () {
      this.canvas.width = this.width
      this.canvas.height = this.height
    },

    /**
     * コンテナの高さを取得
     */
    getHeight () {
      this.height = this.container.clientHeight
    },

    /**
     * コンテナの高さを取得（イベントを間引く）
     */
    throttleGetHeight: _.throttle(function () {
      this.getHeight()
    }, 250),
  },

  watch: {
    width () {
      this.draw()
    },

    height () {
      this.draw()
    },

    borderColor () {
      this.draw()
    },

    measureBackgroundDarkColor () {
      this.draw()
    },
  },
})
